import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 Coréen Express™ (6 Tomes, 120+ pages)',
  price: '27,99€'
}, {
  label: '🎁 Bonus #1 : Dictionnaire visuel Hangeul-Français™',
  price: 'GRATUIT'
}, {
  label: '🎁 Bonus #2 : Reconnaissance en contexte™',
  price: 'GRATUIT'
}, {
  label: '🎁 Bonus #3 : Prononciation — Natifs Coréens™',
  price: 'GRATUIT'
}, {
  label: '🎁 Bonus #4 : Fiche récapitulative K-Drama™',
  price: 'GRATUIT'
}, {
  label: '🎁 Bonus #5 : Planning d’étude personnalisé™',
  price: 'GRATUIT'
}, {
  label: '🛡️ Garantie de satisfaction 7 jours',
  price: 'INCLUS'
}, {
  label: '♾️ Accès à vie & mises à jour gratuites',
  price: 'INCLUS'
}];
const trust = [{
  icon: LockIcon,
  label: 'Paiement 100% Sécurisé'
}, {
  icon: ZapIcon,
  label: 'Livraison Instantanée'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantie 7 jours'
}, {
  icon: CreditCardIcon,
  label: 'Carte de Crédit / Débit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Résumé de l'offre" className="border-y border-grape/10 bg-white/70" data-id="element-186" data-mp="1tda5mav9xepv">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" data-id="element-187" data-mp="1oefgysamkvxu">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-188" data-mp="236r3bpyj7dyt">
          🚀 Commencez à Lire le Coréen en 60 minutes
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-189" data-mp="2c5kuv1x09e5i">
          Lisez le Hangeul, prononcez correctement et construisez vos premières vraies phrases en
          coréen. Un seul paiement, accès illimité, tout prêt à commencer aujourd'hui.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-190" data-mp="2m390imw5g62g">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-191" data-mp="2h2usv5ygmy4y">
            <span data-id="element-192" data-mp="mrpv2ia21fxj">Qu'est-ce qui est inclus</span>
            <span data-id="element-193" data-mp="mt0yggzl8lo4">Prix</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-194" data-mp="2mu7gdtdgsfpk">
              <span className="text-plum/80" data-id="element-195" data-mp="2rsiqm57o8s8b">{r.label}</span>
              <span className={r.price.endsWith('€') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-196" data-mp="2vtkqmo9ex8bc">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-197" data-mp="35sjttrbesbqy">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-198" data-mp="3aql9e29mlsxo">
              Valeur réelle totale : <span className="text-plum/40 line-through" data-id="element-199" data-mp="3fhl7hauheh1r">54€</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" style={{
            fontSize: "64px",
            fontFamily: "Cinzel, serif",
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-200" data-mp="3jjyc1vxhs8wy">
              27€
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-201" data-mp="3ti49o1c9msw0">
              EUR · Paiement unique
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-202" data-mp="2hbzjujeddoy">
              Le paiement sera traité dans votre devise locale.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-203" data-mp="3tp6kdr99v7mt">
          <CTAButton data-id="element-204" data-mp="3pn38x2mls31j">Obtenir Coréen Express</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-205" data-mp="q76bm9vw6y85">
          Vous économisez 27€ (50% de réduction) · Paiement unique
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-206" data-mp="l8bs15q3p5mz">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-207" data-mp="ceqdnnhulqe3">
              <Icon className="h-4 w-4 text-grape" data-id="element-208" data-mp="18y643l2liq66" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}